export const GET_ALL_LIST = 'GET_ALL_LIST';
export const ADD_NEW_FORM = 'ADD_NEW_FORM';
export const EDIT_FORM = 'EDIT_FORM';
export const DELETE_FORM = 'DELETE_FORM';
export const DUPLICATE_FORM = 'DUPLICATE_FORM'
export const SELECT_FORM = 'SELECT_FORM'

export const SET_LOADER = 'SET_LOADER'
export const SET_SETTINGS = 'SET_SETTINGS'
export const RESET_SETTINGS = 'RESET_SETTINGS'
export const CANCEL_SETTINGS = 'CANCEL_SETTINGS'
export const SELECT_TAB = 'SELECT_TAB'
export const SELECT_TEMPLATE = 'SELECT_TEMPLATE'
export const SET_FORM_NAME = 'SET_FORM_NAME'
export const SET_USER_ID = 'SET_USER_ID'
export const SELECT_ELEMENT_FOR_ADDING_TO_FORM = 'SELECT_ELEMENT_FOR_ADDING_TO_FORM'
export const CHANGE_FORM_ELEMENTS_LIST = 'CHANGE_FORM_ELEMENTS_LIST'
export const CHANGE_FORM_OPTIONS_LIST = 'CHANGE_FORM_OPTIONS_LIST'
export const CHANGE_ELEMENT_NAME = 'CHANGE_ELEMENT_NAME'
export const ADD_ELEMENT_TO_LIST = 'ADD_ELEMENT_TO_LIST'
export const DELETE_ELEMENT_FROM_LIST = 'DELETE_ELEMENT_FROM_LIST'
export const ADD_OPTION_TO_LIST = 'ADD_OPTION_TO_LIST'
export const EDIT_ELEMENT = 'EDIT_ELEMENT'
export const SAVE_OPTIONS = 'SAVE_OPTIONS'
export const CHANGE_FLAG = 'CHANGE_FLAG'
export const CHANGE_ISREQUIRED_FLAG = 'CHANGE_ISREQUIRED_FLAG'
export const SELECT_DEFAULT_EDIT_TAB = 'SELECT_DEFAULT_EDIT_TAB'



//*****************  Design TAB TYPES  ***********************/

export const CHANGE_ANY_VALUE = 'CHANGE_ANY_VALUE'
export const CHANGE_FONT_VALUES = 'CHANGE_FONT_VALUES'

//*****************  Design TAB TYPES END ********************/


//*****************  MAIN TYPES  ***********************/

export const SAVE_SUCCESS = 'SAVE_SUCCESS'

//*****************  MAIN TYPES END ********************/

//*****************  FORM TYPES  ***********************/

export const SET_CONFIG = 'SET_CONFIG'
export const CHANGE_CHECKBOX_OPTION = 'CHANGE_CHECKBOX_OPTION'
export const DROPDOWN_CHOOSE_OPTION = 'DROPDOWN_CHOOSE_OPTION'
export const RADIO_CHOOSE_OPTION = 'RADIO_CHOOSE_OPTION'
export const TEXT_CHANGE = 'TEXT_CHANGE'
export const DATE_CHANGE = 'DATE_CHANGE'
export const CLICK_SUBMIT = 'CLICK_SUBMIT'
export const ON_SUBMIT_RESPONSE = 'ON_SUBMIT_RESPONSE'

//*****************  FORM TYPES END ********************/

//*****************  ANSWERS TYPES  ***********************/

export const SET_PRESENTATION_LIST = 'SET_PRESENTATION_LIST'
export const SET_ANSWER_LIST = 'SET_ANSWER_LIST'
export const SELECT_PRESENTATION = 'SELECT_PRESENTATION'
export const SELECT_ANSWER = 'SELECT_ANSWER'
export const SET_ANSWER = 'SET_ANSWER'
export const SET_ANSWERS_LOADER = 'SET_ANSWERS_LOADER'

//*****************  ANSWERS TYPES END ********************/